const en = {
	common: {
		platformTitle: 'FutureFlu',
		platformSubtitle: 'Seasonal Influenza Vaccine Strain Recommendation Platform',
		copyright: 'All rights reserved.',
		developedBy: 'Developed by The WAP Lab',
		switchLang: 'Switch Language',
		home: 'Home',
		help: "help",
		recommendations: 'Recommendations',
		yearLabel: 'Annual Influenza Vaccine',
		headerSubtitle: 'Recommended vaccines for use in the {{year}} influenza season',
		goToCurrentSeason: 'View Current Influenza Season Circulation',
		countryNote: 'Listed countries are the top 5 countries with available sequence data in the Northern Hemisphere.',
		subtype: 'Subtype',
		region: 'Region',
		year: 'Year',
		hemisphere: 'Northern Hemisphere',
		hemisphereSouthern: 'Southern Hemisphere',
		hemisphereLabel: 'Selection by Hemisphere',
		countryLabel: 'Select by Country',
		subtypeH3N2: 'Influenza A (H3N2)',
		subtypeH1N1: 'Influenza A (H1N1)pdm09',
		subtypeB: 'Influenza B (Victoria)',
		countryCN: 'China',
		countryUS: 'USA',
		countryJP: 'Japan',
		countryUK: 'UK',
		countryDE: 'Germany',
		loading: 'Loading data...',
		loadError: 'Failed to load data',
		yes: 'Yes',
		no: 'No',
		high: 'High',
		medium: 'Medium',
		low: 'Low',
		northAmerica: 'North America',
		europe: 'Europe',
		asia: 'Asia',
		southAmerica: 'South America',
		africa: 'Africa',
		oceania: 'Oceania',
		tooltip: 'Please select a past year to view the corresponding data',
		back: 'Back',
		refresh: 'Refresh Data',
		lastUpdated: 'Last Updated',
		noData: 'No Data',
		emptyMsg: 'No critical mutation data',
		noDataDesc: 'No influenza season data available at the moment, please try again later',
		reload: 'Reload',
		loadDataFailed: 'Failed to load data',
		retryLoad: 'Reload',
		refreshData: 'Refresh Data',
		futureflurecommended: 'FutureFlu Recommended',
		whorecommended: 'WHO Recommended',
		phylogeneticTree: 'Phylogenetic Tree',
		en: 'EN',
		zh: '中',
	},
	help: {
		title: 'Help',
		dataSource: {
			title: 'Data Source',
			content: 'The sequence data used for analysis on this website were obtained from the Global Initiative on Sharing All Influenza Data (GISAID) platform: http://platform.gisaid.org/. We gratefully acknowledge the contributions of all healthcare workers and scientists, as well as the support of the GISAID team, the submitting laboratories, and the originating laboratories.'
		},
		contact: {
			title: 'Contact Us',
			organization: 'Institute of Systems Medicine, Chinese Academy of Medical Sciences / Suzhou Institute of Systems Medicine (ISM)',
			email: 'Email',
			address: 'Contact Address',
			addressDetail: 'No. 100 Chongwen Road, Suzhou Industrial Park, Jiangsu Province, China'
		},
		reserved: {
			placeholder: 'This area is reserved for future use'
		}
	},
	home: {
		mainTitle: 'FutureFlu: A Computational Platform for Recommending Seasonal Influenza Vaccine Strains',
		card1Title: 'Surveillance Dynamics of the Current Influenza Season',
		card1Subtitle: 'Real-time tracking of global influenza virus circulation dynamics and clade evolutionary relationship',
		card1Alt: 'Current Season Chart',
		card2Title: 'Potential Dominant Clade Ranking for the Next Influenza Season',
		card2Alt: 'Potential Dominant Lineage Chart',
		card3Title: 'FutureFlu Recommends Vaccine Strains for the Next Influenza Season',
		card3Alt: 'Vaccine Recommendations',
		northernHemisphere: 'Northern Hemisphere',
		southernHemisphere: 'Southern Hemisphere',
		yearText: 'Year',
		seasonText: 'Influenza Season',
		potentialDominantBranches: 'Potential Dominant Lineages and Risk Mutations for Influenza Season',
		vaccineRecommendation: 'Vaccine for Influenza Season',
		computedByFutureFlu: 'Result Calculated by FutureFlu',
		loadSubtypesFailed: 'Failed to load subtype data',
		loadRegionsFailed: 'Failed to load region data',
		loadYearsFailed: 'Failed to load years',
		helpTitle: 'About',
		northernHemisphereInfo: 'Northern Hemisphere: The flu season is from September of year T to February of year T+1, with the forecast made in February of year T.',
		southernHemisphereInfo: 'Southern Hemisphere: The flu season is from February of year T to September of year T, with the forecast made in September of year T-1.',
	},
	currentSeason: {
		title: 'Epidemiological Dynamics of the Current Influenza Season',
		desc: 'Real-time monitoring of global influenza virus circulation, providing the latest basic data for prediction models',
		mainTitle: 'Current Influenza Season Analysis',
		phylogeneticTree: 'Phylogenetic Tree',
		circulationDynamics: 'Circulation Dynamics',
		keyMutations: 'Key Mutations',
		keyMutationsTooltip: 'Data provided by the Nextstrain project',
		keyMetrics: {
			updatedTo: 'Updated to',
			mainSubtype: 'Main Global Subtypes',
			dominantStrain: 'Current Dominant Strain',
			fastestGrowing: 'Fastest Growing Strain in 7 Days',
		},
		regionData: {
			northAmerica: 'North America',
			europe: 'Europe',
			asia: 'Asia',
			southAmerica: 'South America',
			africa: 'Africa',
			oceania: 'Oceania',
			high: 'High',
			medium: 'Medium',
			low: 'Low',
		},
		legend: 'Legend',
		percentage: 'Percentage',
		vaccineNode: 'Vaccine Node',
		nodeDesc1: 'The area of the circle reflects the abundance of sequences represented by the clade',
		nodeDesc2: 'Vaccine nodes are highlighted, hover for details',
		cladeRelation: 'Clade Relationship',
		cladeTree: 'Clade Tree Visualization',
		cladeMutations: 'Key Clade Mutations',
		cladeMutationHeatmap: 'Clade Mutation Heatmap',
		branch: 'Clade',
		mutation: 'Mutation',
		hasMutation: 'Has Mutation',
		axisDesc: 'X-axis: mutation sites, Y-axis: clades, red means the clade has the mutation, hover for details',
		cladeTrends: 'Clade Trends',
		weeklyPercent: 'Weekly clade percentage, color matches the tree, hover for details',
		loadSequenceCountsFailed: 'Failed to load sequence count data',
		loadVaccineStrainsFailed: 'Failed to load vaccine strain information',
		loadTreeDataFailed: 'Failed to load phylogenetic tree data',
		simpleTreeLoadFailed: 'Simple phylogenetic tree loading failed',
		detailedTreeLoadFailed: 'Detailed phylogenetic tree loading failed',
		getSimpleTreeVaccineInfoFailed: 'Failed to get simple tree vaccine strain information',
		getDetailedTreeVaccineInfoFailed: 'Failed to get detailed tree vaccine strain information',
		cannotGetAnyTreeData: 'Cannot get any phylogenetic tree data',
		cannotParseTreeStructure: 'Cannot parse tree structure',
		parseTreeStringFailed: 'Failed to parse tree string',
		loadMutationDataFailed: 'Failed to load mutation data',
		getCirculationDynamicsFailed: 'Failed to get circulation dynamics data',
		getSubcladeMapFailed: 'Failed to get subclade mapping data, will use empty mapping',
		loadSubcladeMapFailed: 'Failed to load subclade mapping data',
	},
	phylogeneticTree: {
		legend: 'Legend',
		clades: 'Clades',
		vaccineStrains: 'Vaccine Strains',
		console: {
			treeStringChanged: 'Tree string changed',
			cladeColorsChanged: 'Clade colors mapping changed',
			originalTreeString: 'Original tree string',
			cannotParseTree: 'Cannot parse tree structure, using original string',
			nodeAnalysis: 'Node branching analysis',
			reorganizedTreeString: 'Reorganized tree string',
			reorganizeFailed: 'Failed to reorganize tree structure',
			parseTreeFailed: 'Failed to parse tree string',
			customLayoutComplete: 'Custom layout completed, sorted leaf nodes',
			customLayoutFailed: 'Custom layout algorithm failed, using default layout',
			analyzeTreeFailed: 'Failed to analyze tree structure',
			nodeInfo: 'Node branching information'
		}
	},
	candidates: {
		tooltipContent: 'Epitope Mutations column: Amino acid type at the comparison site + site number + amino acid type in the next-season recommended vaccine strain',
		AntigenicTooltipContent: 'Antigenic Similarity column: Directional HI similarity result relative to reference antisera, derived from the Francis Crick Institute (Worldwide Influenza Centre) antigenic assay reports.',
		title: 'Dominant Lineage Ranking for Next Season',
		desc: 'Ranking of viral clade fitness predicted by PHER deep learning model',
		rank: 'Rank',
		branch: 'Clade',
		strain: 'Strain',
		fitness: 'Fitness',
		confidence: 'Confidence',
		coverage: 'Coverage',
		mutations: 'Key Mutations',
		high: 'High',
		medium: 'Medium',
		low: 'Low',
		northAmerica: 'North America',
		europe: 'Europe',
		asia: 'Asia',
		southAmerica: 'South America',
		africa: 'Africa',
		oceania: 'Oceania',
		predictionTarget: {
			title: 'Prediction Target',
			season: '2025-2026 Influenza Season',
			virusSubtype: 'Influenza A H3N2 Subtype',
			modelConfidence: 'Model Confidence: 92.3%',
		},
		evolutionTree: {
			title: 'Viral Evolution Tree',
			desc: 'Shows evolutionary relationships and fitness predictions for each clade',
			placeholder: {
				virusEvolutionTree: 'Viral Evolution Tree Visualization',
				evolutionTreeDesc: 'Shows evolutionary relationships and fitness prediction results for each clade',
			},
			legend: {
				highAdaptability: 'High Fitness Clades',
				mediumAdaptability: 'Medium Fitness Clades',
				lowAdaptability: 'Low Fitness Clades',
				currentPopularBranch: 'Currently Circulating Clades',
			},
		},
		modelInfo: {
			title: 'PHER Model Information',
			desc: 'Detailed parameters of the deep learning prediction model',
			modelVersion: 'Model Version',
			trainingData: 'Training Data',
			predictionAccuracy: 'Prediction Accuracy',
			featureDimension: 'Feature Dimension',
			updateFrequency: 'Update Frequency',
		},
		predictionTrend: {
			title: 'Prediction Trends',
			branch3C2A1b2a2: '3C.2A1b.2a.2 clade continues to grow',
			k156eMutation: 'K156E mutation significantly increasing',
			f159yMutation: 'F159Y mutation requires attention',
		},
		table: {
			title: 'Detailed Candidate Clade Ranking',
			desc: 'Clade fitness ranking results based on PHER model predictions',
			rank: 'Rank',
			branch: 'Clade',
			strain: 'Representative Strain',
			fitness: 'Fitness',
			confidence: 'Confidence',
			coverage: 'Coverage',
			mutations: 'Key Mutations',
		},
		searchPlaceholder: 'Search clades or mutation information...',
		refreshData: 'Refresh Data',
		exportData: 'Export Data',
		candidateBranches: 'Candidate Clades',
		riskMutations: 'Risk Mutations',
		topScore: 'Top Score',
		loading: 'Loading...',
		noData: 'No Data',
		noDataDescription: 'Please check data source or refresh page',
		loadDataFailed: 'Failed to load CSV data',
		dataLoadFailed: 'Data loading failed',
		nextSeasonDominantScore: 'Dominant transmission score for next influenza season',
		cladeRiskMutations: 'Risk mutations in clade',
		candidateBranchAnalysisData: 'Candidate branch analysis data',
	},
	recommendations: {
		title: 'Vaccine Strains Recommended for Next Season',
		desc: 'Final vaccine strain recommendations based on prediction results, providing scientific basis for decision makers',
		pageTitle: 'Comparison of the recommended vaccine strains for the next season with the current epidemiological landscape',
		showSimpleTree: 'Show Simplified Phylogenetic Tree',
		showDetailedTree: 'Show Detailed Phylogenetic Tree',
		loading: 'Loading...',
		noData: 'No Data',
		tableColumns: {
			category: 'Category',
			haDifference: 'HA Amino Acid Differences',
			epitopeMutations: 'Antigenic Epitope Site Mutations',
			antigenicResult: 'Antigenic Significance Difference Result'
		},
		antigenicResults: {
			similar: 'Antigenically Similar',
			different: 'Antigenically Different'
		},
		keyInsights: {
			confidence: 'Recommendation Confidence',
			confidenceValue: '92.3%',
			confidenceDesc: 'Comprehensive evaluation based on PHER model',
			protection: 'Expected Protection',
			protectionValue: '78-85%',
			protectionDesc: 'Protection rate for predicted dominant clades',
			coverage: 'Geographical Coverage',
			coverageValue: '85%',
			coverageDesc: 'Coverage in global epidemic regions',
			risk: 'Risk Assessment',
			riskValue: 'Low',
			riskDesc: 'Matching risk between vaccine and predicted clades',
		},
		table: {
			title: 'Vaccine Strain Recommendation Table',
			desc: 'Detailed vaccine strain recommendations based on prediction results',
			level: {
				header: 'Priority',
				首选: 'Primary',
				备选: 'Alternative',
			},
			strain: {
				header: 'Strain',
			},
			branch: {
				header: 'Clade',
			},
			antigenicDistance: {
				header: 'Antigenic Distance',
			},
			coverage: {
				header: 'Coverage',
			},
			confidence: {
				header: 'Confidence',
				高: 'High',
				中: 'Medium',
				低: 'Low',
			},
			mutations: {
				header: 'Key Mutations',
			},
			rationale: {
				header: 'Rationale',
				'最高适应性预测，广泛地理覆盖': 'Highest fitness prediction with broad geographic coverage',
				'亚洲地区优势分支，适应性良好': 'Dominant clade in Asia with good fitness',
				'南美地区流行，中等适应性': 'Circulating in South America with medium fitness',
			},
		},
		disclaimerTitle: 'Disclaimer',
		disclaimer: 'This recommendation is based on PHER deep learning model predictions and is for scientific reference only. Final vaccine strain selection should be based on the comprehensive evaluation and decision of the WHO expert committee. The accuracy of the prediction is affected by many factors, including the uncertainty of virus evolution, data quality, and model limitations.',
		antigenMap: 'Antigenic Cartography',
		antigenMapDesc: '2D antigenic map shows antigenic distance between recommended and circulating strains',
		antigenMapPlaceholder: '[Placeholder] 2D antigenic map shows the relationship between vaccine and circulating strains',
		antigenicMap: {
			title: 'Antigenic Cartography',
			desc: '2D antigenic map shows antigenic distance between recommended and circulating strains',
			placeholderTitle: '2D Antigenic Map Visualization',
			placeholderDesc: 'Shows antigenic relationships between recommended vaccine strains and circulating strains',
			legend: {
				recommended: 'Recommended Vaccine Strains',
				current: 'Current Circulating Strains',
				predicted: 'Predicted Dominant Strains',
				historical: 'Historical Vaccine Strains',
			},
		},
		timeline: {
			title: 'Decision Timeline',
			desc: 'Key milestones in WHO vaccine strain selection',
			'2024': 'December 2024',
			'2024Desc': 'Data collection and analysis completed',
			'2025Feb': 'February 2025',
			'2025FebDesc': 'WHO expert committee meeting',
			'2025Mar': 'March 2025',
			'2025MarDesc': 'Vaccine strain recommendation published',
			'2025Sep': 'September 2025',
			'2025SepDesc': 'Vaccine production and distribution',
		},
		quality: {
			title: 'Data Quality Assessment',
			desc: 'Reliability indicators of recommendation results',
			dataIntegrity: 'Data Integrity',
			dataIntegrityValue: '96%',
			modelAccuracy: 'Model Accuracy',
			modelAccuracyValue: '92%',
			geographicCoverage: 'Geographic Coverage',
			geographicCoverageValue: '85%',
			timeliness: 'Timeliness',
			timelinessValue: '100%',
		},
		phylogeneticTreeText: 'Phylogenetic Tree',
		loadSequenceCountsFailed: 'Failed to get sequence count data',
		loadVaccineStrainsFailed: 'Failed to load vaccine strain information',
		getSimpleTreeVaccineInfoFailed: 'Failed to get simple tree vaccine strain information',
		getDetailedTreeVaccineInfoFailed: 'Failed to get detailed tree vaccine strain information',
		cannotGetAnyTreeData: 'Cannot get any phylogenetic tree data',
		simpleTreeLoadFailed: 'Simple phylogenetic tree loading failed',
		detailedTreeLoadFailed: 'Detailed phylogenetic tree loading failed',
		loadTreeDataFailed: 'Failed to load phylogenetic tree data',
	},
	phylogeneticTree: {
		legend: 'Legend',
		clades: 'Clades',
		vaccineStrains: 'Vaccine Strains',
		vaccineStrainDisplay: "Vaccine Strains Recommended for the Current Influenza Season",
		vaccineStrainDisplaynext: "Vaccine Strains Recommended for the Next Influenza Season",
		futureflurecommended: 'FutureFlu Recommended',
		whorecommended: 'WHO Recommended',
		tooltip: {
			branch: 'Branch',
			normalBranch: 'Normal Branch',
			sequenceId: 'Sequence ID',
			branchName: 'Branch Name',
			nodeName: 'Node Name',
			sequenceCount: 'Sequence Count',
			branchColor: 'Branch Color',
			status: 'Status',
		},
		console: {
			treeStringChanged: 'Tree string changed:',
			cladeColorsChanged: 'Clade colors mapping changed:',
			originalTreeString: 'Original tree string:',
			cannotParseTree: 'Cannot parse tree structure, using original string',
			nodeAnalysis: 'Node branching analysis:',
			reorganizedTreeString: 'Reorganized tree string:',
			reorganizeFailed: 'Failed to reorganize tree structure:',
			parseTreeFailed: 'Failed to parse tree string:',
			nodeInfo: 'Node branching information:',
			customLayoutComplete: 'Custom layout completed, leaf nodes sorted',
			customLayoutFailed: 'Custom layout algorithm failed, using default layout',
			analyzeTreeFailed: 'Failed to analyze tree structure',
			renderTreeString: 'Reorganized tree string during rendering'
		}
	}
}
export default en